import type { GridColumnVisibilityModel } from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import DocumentDialogIcon from "@entrilia/shared/icons/DocumentDialogIcon";
import type { DataCollectionSubmissionInfo } from "../../api/types/dataCollectionTypes";
import { columnDefinitions } from "./dataSubmissionsGridDataProvider";

interface Props {
  rows: DataCollectionSubmissionInfo[];
  noRowsText: string;
  isLoading: boolean;
  hiddenColumns?: string[];
}

const DataSubmissionsGrid = ({ rows, noRowsText, isLoading, hiddenColumns }: Props) => {
  const columnVisibilityModel = useMemo<GridColumnVisibilityModel>(
    () => (hiddenColumns ?? []).reduce((result, field) => ({ ...result, [field]: false }), {}),
    [hiddenColumns]
  );

  return (
    <DataGrid<DataCollectionSubmissionInfo>
      rows={rows}
      columns={columnDefinitions}
      columnVisibilityModel={columnVisibilityModel}
      loading={isLoading}
      noRowsIcon={<DocumentDialogIcon sx={{ width: 80, height: 80 }} />}
      noRowsText={noRowsText}
      disableColumnReorder
      disableColumnSorting
    />
  );
};

export default DataSubmissionsGrid;
